// The „Więcej w przewodniku:” line of a help popup: a link to the Metroskop guide
// (https://metroskop.pl/przewodnik), which explains a term the popup can only name.
// The popup runtime (assets/public/js/info-popup.js) renders the line as a link.
// Mirrors `common\modules\rcn\helpers\GuideLink::line()`; the path must be one of
// `GuideLink::PATHS` (GuideLinkTest checks every call in assets-src).

export const GUIDE_BASE_URL = 'https://metroskop.pl/przewodnik/';

/**
 * @param {string} path guide page below the base address, e.g. 'slownik#mediana'
 * @param {string} title link text: the name of the term or of the instruction
 * @returns {string}
 */
export function guideLine(path, title) {
    return 'Więcej w przewodniku: ' + title + ' — ' + GUIDE_BASE_URL + path;
}
